// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Js_exn from "rescript/lib/es6/js_exn.js";
import * as Recoil from "recoil";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Caml_js_exceptions from "rescript/lib/es6/caml_js_exceptions.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as Window$OrcaPaymentPage from "../Window.bs.js";
import * as CardTheme$OrcaPaymentPage from "../CardTheme.bs.js";
import * as CardUtils$OrcaPaymentPage from "../CardUtils.bs.js";
import * as ApiEndpoint$OrcaPaymentPage from "../Utilities/ApiEndpoint.bs.js";
import * as CardPayment$OrcaPaymentPage from "./CardPayment.bs.js";
import * as HyperLogger$OrcaPaymentPage from "../hyper-log-catcher/HyperLogger.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";
import * as DefaultTheme$OrcaPaymentPage from "../DefaultTheme.bs.js";
import * as RecoilAtomsV2$OrcaPaymentPage from "../Utilities/RecoilAtomsV2.bs.js";
import * as CommonCardProps$OrcaPaymentPage from "../Hooks/CommonCardProps.bs.js";
import * as PaymentHelpersV2$OrcaPaymentPage from "../Utilities/PaymentHelpersV2.bs.js";
import * as UnifiedHelpersV2$OrcaPaymentPage from "../Utilities/UnifiedHelpersV2.bs.js";
import * as HyperVaultHelpers$OrcaPaymentPage from "../Utilities/HyperVaultHelpers.bs.js";
import * as PaymentManagementBody$OrcaPaymentPage from "../Utilities/PaymentManagementBody.bs.js";

function CardVault(props) {
  var match = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.configAtom);
  var setConfig = match[1];
  var match$1 = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.keys);
  var setKeys = match$1[1];
  var keys = match$1[0];
  var match$2 = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.customPodUri);
  var localeString = match[0].localeString;
  var setCustomPodUri = match$2[1];
  var customPodUri = match$2[0];
  var match$3 = Recoil.useRecoilState(RecoilAtomsV2$OrcaPaymentPage.vaultPublishableKey);
  var setVaultPublishableKey = match$3[1];
  var vaultPublishableKey = match$3[0];
  var match$4 = Recoil.useRecoilState(RecoilAtomsV2$OrcaPaymentPage.vaultProfileId);
  var setVaultProfileId = match$4[1];
  var vaultProfileId = match$4[0];
  var setPaymentMethodsList = Recoil.useSetRecoilState(RecoilAtomsV2$OrcaPaymentPage.paymentMethodsListV2);
  var contentRef = React.useRef(null);
  var observer = new ResizeObserver((function (entries) {
          entries.forEach(function (entry) {
                var newHeight = entry.contentRect.height;
                Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
                        "cardIframeContentHeight",
                        newHeight
                      ]]);
              });
        }));
  var val = contentRef.current;
  if (!(val == null)) {
    observer.observe(val);
  }
  var match$5 = React.useMemo((function () {
          return [
                  HyperLogger$OrcaPaymentPage.make(undefined, {
                        TAG: "Elements",
                        _0: "PaymentMethodsManagement"
                      }, undefined, undefined, undefined, undefined),
                  Date.now()
                ];
        }), []);
  var logger = match$5[0];
  var match$6 = CommonCardProps$OrcaPaymentPage.useCardForm(logger, "Payment");
  var cvcProps = match$6.cvcProps;
  var setCvcError = cvcProps.setCvcError;
  var cvcNumber = cvcProps.cvcNumber;
  var isCVCValid = cvcProps.isCVCValid;
  var expiryProps = match$6.expiryProps;
  var setExpiryError = expiryProps.setExpiryError;
  var cardExpiry = expiryProps.cardExpiry;
  var isExpiryValid = expiryProps.isExpiryValid;
  var cardProps = match$6.cardProps;
  var cardBrand = cardProps.cardBrand;
  var setCardError = cardProps.setCardError;
  var cardNumber = cardProps.cardNumber;
  var isCardSupported = cardProps.isCardSupported;
  var isCardValid = cardProps.isCardValid;
  React.useEffect((function () {
          Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
                  "innerIframeMountedCallback",
                  true
                ]]);
          var handle = function (ev) {
            var handleIframeValues = async function () {
              try {
                var json = Utils$OrcaPaymentPage.safeParse(ev.data);
                var dict = Utils$OrcaPaymentPage.getDictFromJson(json);
                if (!Core__Option.isSome(dict["innerIframeMounted"])) {
                  return ;
                }
                var metadata = Utils$OrcaPaymentPage.getJsonObjectFromDict(dict, "metadata");
                var metadataDict = Utils$OrcaPaymentPage.getDictFromJson(metadata);
                setPaymentMethodsList(function (param) {
                      return UnifiedHelpersV2$OrcaPaymentPage.createPaymentsObjArr(metadataDict, "paymentList");
                    });
                var match = HyperVaultHelpers$OrcaPaymentPage.extractVaultMetadata(metadataDict);
                var customPodUri = match.customPodUri;
                var vaultProfileId = match.vaultProfileId;
                var vaultPublishableKey = match.vaultPublishableKey;
                var pmClientSecret = match.pmClientSecret;
                var pmSessionId = match.pmSessionId;
                setCustomPodUri(function (param) {
                      return customPodUri;
                    });
                ApiEndpoint$OrcaPaymentPage.setApiEndPoint(match.endpoint);
                setKeys(function (prev) {
                      var newrecord = Caml_obj.obj_dup(prev);
                      newrecord.pmClientSecret = pmClientSecret;
                      newrecord.pmSessionId = pmSessionId;
                      return newrecord;
                    });
                setVaultPublishableKey(function (param) {
                      return vaultPublishableKey;
                    });
                setVaultProfileId(function (param) {
                      return vaultProfileId;
                    });
                var configValue = Utils$OrcaPaymentPage.getDictFromJson(match.config);
                var match$1 = CardTheme$OrcaPaymentPage.itemToObjMapper(configValue, DefaultTheme$OrcaPaymentPage.default, DefaultTheme$OrcaPaymentPage.defaultRules, logger);
                var sdkAuthorization = match$1.sdkAuthorization;
                var loader = match$1.loader;
                var fonts = match$1.fonts;
                var clientSecret = match$1.clientSecret;
                var themePmSessionId = match$1.pmSessionId;
                var themePmClientSecret = match$1.pmClientSecret;
                var ephemeralKey = match$1.ephemeralKey;
                var locale = match$1.locale;
                var appearance = match$1.appearance;
                var localeObject = await CardTheme$OrcaPaymentPage.getLocaleObject(locale === "" ? "auto" : locale);
                var constantString = await CardTheme$OrcaPaymentPage.getConstantStringsObject();
                return setConfig(function (param) {
                            return {
                                    config: {
                                      appearance: appearance,
                                      locale: locale === "auto" ? window.navigator.language : locale,
                                      ephemeralKey: ephemeralKey,
                                      pmClientSecret: themePmClientSecret,
                                      pmSessionId: themePmSessionId,
                                      clientSecret: clientSecret,
                                      fonts: fonts,
                                      loader: loader,
                                      sdkAuthorization: sdkAuthorization
                                    },
                                    themeObj: appearance.variables,
                                    localeString: localeObject,
                                    constantString: constantString,
                                    showLoader: loader === "Auto" || loader === "Always"
                                  };
                          });
              }
              catch (raw_exn){
                var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
                if (exn.RE_EXN_ID === Js_exn.$$Error) {
                  console.error("Error in handling - handleIframeValues");
                  return ;
                }
                throw exn;
              }
            };
            handleIframeValues();
          };
          window.addEventListener("message", handle);
          return (function () {
                    window.removeEventListener("message", handle);
                  });
        }), []);
  var handleSaveCard = async function (ev) {
    Utils$OrcaPaymentPage.messageParentWindow(undefined, [
          [
            "fullscreen",
            true
          ],
          [
            "param",
            "paymentloader"
          ]
        ]);
    var match = CardUtils$OrcaPaymentPage.getExpiryDates(cardExpiry);
    var cardNetwork = [[
        "card_network",
        cardBrand !== "" ? cardBrand : null
      ]];
    var defaultCardBody = PaymentManagementBody$OrcaPaymentPage.saveCardBody(cardNumber, match[0], match[1], Caml_option.some(undefined), cvcNumber, cardNetwork, undefined);
    try {
      var res = await PaymentHelpersV2$OrcaPaymentPage.savePaymentMethod(defaultCardBody, Core__Option.getOr(keys.pmSessionId, ""), Core__Option.getOr(keys.pmClientSecret, ""), vaultPublishableKey, vaultProfileId, customPodUri);
      var dict = Utils$OrcaPaymentPage.getDictFromJson(res);
      var sessionResponse = Utils$OrcaPaymentPage.getStrArray(dict, "associated_payment_methods");
      var paymentToken = sessionResponse[0];
      if (Core__Option.isSome(paymentToken)) {
        var msg = Object.fromEntries([[
                "paymentToken",
                Core__Option.getOr(paymentToken, "")
              ]]);
        return Window$OrcaPaymentPage.sendPostMessage(ev.source, msg);
      }
      var msg$1 = Object.fromEntries([[
              "errorMsg",
              "Payment token not found"
            ]]);
      Window$OrcaPaymentPage.sendPostMessage(ev.source, msg$1);
      console.error("Payment token not found ");
      return ;
    }
    catch (raw_err){
      var err = Caml_js_exceptions.internalToOCamlException(raw_err);
      if (err.RE_EXN_ID === Js_exn.$$Error) {
        var err$1 = err._1;
        var errorMsg = Core__Option.getOr(err$1.message, "Something went wrong");
        var msg$2 = Object.fromEntries([[
                "errorMsg",
                errorMsg
              ]]);
        Window$OrcaPaymentPage.sendPostMessage(ev.source, msg$2);
        var exceptionMessage = JSON.stringify(Utils$OrcaPaymentPage.formatException(Caml_js_exceptions.internalToOCamlException(err$1)));
        console.error("Unable to Save Card ", exceptionMessage);
        return ;
      }
      throw err;
    }
  };
  React.useEffect((function () {
          var handle = function (ev) {
            var json = Utils$OrcaPaymentPage.safeParse(Utils$OrcaPaymentPage.getStringFromJson(ev.data, ""));
            var dict = Utils$OrcaPaymentPage.getDictFromJson(json);
            if (!Core__Option.isSome(dict["generateToken"])) {
              return ;
            }
            var isCardDetailsValid = Core__Option.getOr(isCVCValid, false) && Core__Option.getOr(isCardValid, false) && Core__Option.getOr(isCardSupported, false) && Core__Option.getOr(isExpiryValid, false);
            if (isCardDetailsValid) {
              handleSaveCard(ev);
              return ;
            }
            if (cardNumber === "") {
              setCardError(function (param) {
                    return localeString.cardNumberEmptyText;
                  });
              Utils$OrcaPaymentPage.postFailedSubmitResponseTop("validation_error", localeString.enterFieldsText);
            } else if (!Core__Option.getOr(isCardSupported, true)) {
              if (cardBrand === "") {
                setCardError(function (param) {
                      return localeString.enterValidCardNumberErrorText;
                    });
                Utils$OrcaPaymentPage.postFailedSubmitResponseTop("validation_error", localeString.enterValidDetailsText);
              } else {
                setCardError(function (param) {
                      return localeString.cardBrandConfiguredErrorText(cardBrand);
                    });
                var message = localeString.cardBrandConfiguredErrorText(cardBrand);
                Utils$OrcaPaymentPage.postFailedSubmitResponseTop("validation_error", message);
              }
            }
            if (cardExpiry === "") {
              setExpiryError(function (param) {
                    return localeString.cardExpiryDateEmptyText;
                  });
              Utils$OrcaPaymentPage.postFailedSubmitResponseTop("validation_error", localeString.enterFieldsText);
            }
            if (cvcNumber === "") {
              setCvcError(function (param) {
                    return localeString.cvcNumberEmptyText;
                  });
              Utils$OrcaPaymentPage.postFailedSubmitResponseTop("validation_error", localeString.enterFieldsText);
            }
            if (!isCardDetailsValid) {
              return Utils$OrcaPaymentPage.postFailedSubmitResponseTop("validation_error", localeString.enterValidDetailsText);
            }
            
          };
          window.addEventListener("message", handle);
          return (function () {
                    window.removeEventListener("message", handle);
                  });
        }), [
        cardNumber,
        cardExpiry,
        cvcNumber
      ]);
  return React.createElement("div", {
              ref: Caml_option.some(contentRef)
            }, React.createElement(CardPayment$OrcaPaymentPage.make, {
                  cardProps: cardProps,
                  expiryProps: expiryProps,
                  cvcProps: cvcProps,
                  isVault: true
                }));
}

var make = CardVault;

var $$default = CardVault;

export {
  make ,
  $$default as default,
}
/* react Not a pure module */
